module.exports = __webpack_public_path__ + "img/Customs-clearance-hero.e0938274.jpg";